export default __webpack_public_path__ + "static/media/job_offer_timeless.c74c3819.pdf";